import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const DateOfBirthEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const demographics = useAppSelector(state => state.registration.currentRegistration?.demographics) || {};
  
  // Convert ISO datetime string to YYYY-MM-DD format for date input
  const formatDateForInput = (dateString: string | undefined): string => {
    if (!dateString) return '';
    try {
      // Extract just the date part from ISO string (e.g., "1978-11-11T00:00:00" -> "1978-11-11")
      return dateString.split('T')[0];
    } catch {
      return '';
    }
  };
  
  const value = formatDateForInput(demographics.dateOfBirth);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      demographics: {
        ...demographics,
        dateOfBirth: e.target.value,
      },
    }));
  };

  return (
    <TextField
      type="date"
      value={value}
      onChange={handleChange}
      size="small"
      label="Date of Birth"
      InputLabelProps={{ shrink: true }}
      sx={{ width: 200 }}
    />
  );
};

export default DateOfBirthEdit;
